import { createFileRoute } from "@tanstack/react-router";

import { BASE_URL, OG_VERSION } from "@/common/links";
import { getPageContent } from "@/features/docs/content";
import { DocPage } from "@/landing/docs/DocPage";
import { PAGE_META } from "@/landing/lib/page-meta";

export const Route = createFileRoute("/_steward/docs/")({
  component: DocsIndexPage,
  head: () => ({
    meta: [
      { title: PAGE_META["/docs"].title },
      { name: "description", content: PAGE_META["/docs"].description },
      { property: "og:title", content: PAGE_META["/docs"].title },
      { property: "og:description", content: PAGE_META["/docs"].description },
      {
        property: "og:image",
        content: `${BASE_URL}/og/docs.png?v=${OG_VERSION}`,
      },
      { name: "twitter:title", content: PAGE_META["/docs"].title },
      { name: "twitter:description", content: PAGE_META["/docs"].description },
      {
        name: "twitter:image",
        content: `${BASE_URL}/og/docs.png?v=${OG_VERSION}`,
      },
    ],
    links: [{ rel: "canonical", href: `${BASE_URL}/docs` }],
  }),
});

function DocsIndexPage() {
  const page = getPageContent("overview");
  if (!page) return null;

  return (
    <DocPage
      title={page.title}
      description={page.description}
      content={page.content}
    />
  );
}
